import { DEFAULT_LOCALE, VALID_LOCALES, type ValidLocale } from '@/constants';

/**
 * Returns locale based only on the URL path (single source of truth for SEO).
 * - If the first path segment is a valid locale → that locale.
 * - Otherwise (no prefix or unknown) → DEFAULT_LOCALE from config.
 * Use this for HTML lang and hreflang consistency; do not use cookie/query/geo here.
 */
export const getLocaleFromPath = (pathname: string): ValidLocale => {
	if (!pathname) {
		return DEFAULT_LOCALE;
	}
	const pathWithoutQuery = pathname.split('?')[0] ?? '';
	const segments = pathWithoutQuery.split('/').filter(Boolean);
	const firstSegment = segments[0]?.toLowerCase();
	if (firstSegment && VALID_LOCALES.includes(firstSegment)) {
		return firstSegment;
	}
	return DEFAULT_LOCALE;
};
